export const isSftpIntegrationEnabled = (): boolean =>
  process.env.REACT_APP_SFTP_INTEGRATION_ENABLED?.toLowerCase() !== 'false';
